import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { background } from './tempests.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/230531/limited-edition/tempests-le_mclarenplus-{nnn}.png',
}

export default {
  supports360: false,
  layers: [background, body],
  resolveOptions: () => ({
    reflections: 'none',
  }),
}
